import React from 'react';
import { useLang } from '../LanguageContext';

const History = ({ hideHeading = false }) => {
  const { t, timeline } = useLang();

  return (
    <section id="history" className="relative bg-[#0d1b36] py-28 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage: 'radial-gradient(#d4a94c 1px, transparent 1px)',
          backgroundSize: '28px 28px'
        }}
      />

      <div className="relative max-w-6xl mx-auto px-6">
        {!hideHeading && (
          <div className="grid md:grid-cols-5 gap-10 mb-16">
            <div className="md:col-span-3">
              <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-6">
                {t.history.eyebrow}
              </p>
              <h2 className="font-serif text-5xl md:text-6xl text-[#f6ecd9] leading-[1.08]">
                {t.history.t1}<br />
                <em className="italic font-light">{t.history.t2}</em>
              </h2>
            </div>
          </div>
        )}

        <div className="grid md:grid-cols-2 gap-16 items-start">
          <div className="space-y-6">
            <div className="bg-[#f6ecd9] rounded-2xl p-10 flex items-center justify-center aspect-[4/3] overflow-hidden">
              <img
                src="https://customer-assets-eiarnc6j.emergentagent.net/job_murat-sweet/artifacts/c7p1pt64_LOGO%20MURAT.jpg"
                alt="Logo Murat — Depuis 1985 · Feuilletées & Pâtisseries"
                className="max-w-[85%] max-h-[85%] object-contain"
              />
            </div>
            <div className="rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://images.unsplash.com/photo-1517686469429-8bdb88b9f907?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Artisan hands"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>

          <div className="relative pl-8 md:pl-12">
            <div className="absolute left-[7px] md:left-[11px] top-2 bottom-2 w-px bg-gradient-to-b from-[#d4a94c]/60 via-[#d4a94c]/30 to-transparent" />
            <div className="space-y-14">
              {timeline.map((tl, i) => (
                <div key={i} className="relative">
                  <div className="absolute -left-8 md:-left-12 top-1.5 w-4 h-4 rounded-full border-2 border-[#d4a94c] bg-[#0d1b36]" />
                  <p className="text-[11px] tracking-[0.35em] uppercase text-[#d4a94c] mb-3">
                    {tl.year}
                  </p>
                  <h3 className="font-serif text-3xl text-[#f6ecd9] mb-3">
                    {tl.title}
                  </h3>
                  <p className="text-[#f6ecd9]/70 text-sm leading-relaxed max-w-md">
                    {tl.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default History;
